// src/directives/hover.js
export default {
    bind(el, binding) {
        console.log(binding)
      el.mouseOverHandler = () => {
        //binding.value(true);
      };
      el.mouseOutHandler = () => {
        //binding.value(false);
      };
      el.addEventListener('mouseover', el.mouseOverHandler);
      el.addEventListener('mouseout', el.mouseOutHandler);
    },
    unbind(el) {
      el.removeEventListener('mouseover', el.mouseOverHandler);
      el.removeEventListener('mouseout', el.mouseOutHandler);
    }
  };